import { Box, Button, Text, VStack } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ErrorPageSVG from '../../../../../common/src/assets/images/ErrorPageSvg';
import WeGroupLogo from '../../../../../common/src/assets/WeGroupLogo';
import GeneralPageLayout from '../../../../../common/src/components/GeneralPageLayout';

interface Props {
  errorMessage?: string;
}

const RedirectErrorPage: React.FC<Props> = ({ errorMessage }) => {
  const { t } = useTranslation();

  return (
    <GeneralPageLayout h="100%">
      <VStack h="100%">
        <Box as={Link} w="80" cursor="pointer" to="/dashboard">
          <WeGroupLogo />
        </Box>

        <VStack justify="center" flexGrow={1} pb="32" spacing="10">
          <ErrorPageSVG />
          <VStack spacing="2">
            <Text textStyle="h3Headline">{t('Redirect failed')}</Text>
            {errorMessage && (
              <Text textStyle="body" color="gray.500" textAlign="center">
                {errorMessage}
              </Text>
            )}
            <Button as={Link} variant="ghost" to="/dashboard">
              {t('BACK-TO-DASHBOARD')}
            </Button>
          </VStack>
        </VStack>
      </VStack>
    </GeneralPageLayout>
  );
};

export default RedirectErrorPage;
